import axios from 'axios'

const baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:5000/' : 'http://bry.ar-email.com.br:5000/'

export default axios.create({
  baseURL
})



// WEBPACK FOOTER //
// ./src/http.js